import { Image } from 'expo-image';
import { View, XStack, YStack } from 'tamagui';
import PSText from './ui/PSText';
import EventLocation from './EventLocation';
import MaybeGrayscale from './ui/MaybeGrayscale';

const IMAGE_W = 112;
const RATIO = 4 / 3;
const IMAGE_H = IMAGE_W * RATIO;

export default function CheckoutEventHeader({
  imageUrl,
  title,
  slotDisplay,
  venueName,
  googleMapsUrl,
  grayScale = false,
}: {
  grayScale?: boolean;
  imageUrl: string;
  title: string;
  slotDisplay: string;
  venueName: string;
  googleMapsUrl: string;
}) {
  return (
    <YStack gap={'$space.lg'}>
      <XStack gap="$md" items="flex-start">
        <MaybeGrayscale enabled={grayScale}>
          <View
            width={IMAGE_W}
            height={IMAGE_H}
            rounded="$base"
            overflow="hidden"
          >
            <Image
              source={{ uri: imageUrl }}
              style={{ width: IMAGE_W, height: IMAGE_H }}
              contentFit="cover"
              transition={200}
            />
          </View>
        </MaybeGrayscale>

        {/* space-between pins the title to the top and the location to the
          bottom; the column matches the image's height so the two anchor to
          its edges. */}
        <YStack flex={1} justify="center" gap={'$space.md'}>
          <PSText.H1 color="$textDark" numberOfLines={5}>
            {title}
          </PSText.H1>
        </YStack>
      </XStack>
      <YStack gap={'$space.sm'}>
        <PSText.Body2>{slotDisplay}</PSText.Body2>
        <EventLocation venueName={venueName} googleMapsUrl={googleMapsUrl} />
      </YStack>
    </YStack>
  );
}
